import { Button, Flexer } from '@ontruck/orc';
import { useFormState } from 'react-hook-form';

const VenueCreateButton = () => {
  const { isSubmitting } = useFormState();
  return (
    <Flexer.Parent justifyContent="flex-end" m="S">
      <Button text="Create POI" disabled={isSubmitting} type="submit" />
    </Flexer.Parent>
  );
};

export default VenueCreateButton;
